"use client";

import Image from "next/image";
import React, { useCallback, useEffect, useRef, useState } from "react";

interface NewPresenceProps {
  pageName: string;
  /* Sections that already carry their own heading (e.g. the CMA course page)
     can suppress the built-in one; every existing caller keeps it. */
  hideHeading?: boolean;
  /* Renders without the section background, padding and white card so the
     host can place this inside its own container. */
  embedded?: boolean;
}

interface CityData {
  name: string;
  icon: string;
  address: string;
  email: string;
  phone: string;
  mapUrl: string;
}

const officeImages = [
  "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/office1.png?tr=f-webp",
  "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/office2.png?tr=f-webp",
  "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/office3.png?tr=f-webp",
  "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/office4.png?tr=f-webp",
  "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/office5.png?tr=f-webp",
  "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/office6.png?tr=f-webp",
];

const cities: CityData[] = [
  {
    name: "Bangalore",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/bangalore.webp",
    address:
      "Miles Education - CPA, CMA & CAIRA (Bangalore), 2nd Floor, Mantri Avenue, 20th Main Rd, Koramangala 8th Block, Koramangala, Bengaluru, Karnataka 560095",
    email: "bangalore@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Miles+Education+CPA+CMA+Koramangala+8th+Block+Bangalore&t=&z=15&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Hyderabad",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/hyderabad.webp",
    address:
      "Level - 1, Jayabheri Silicon Towers, Hitech City Road, Kothaguda, Hyderabad - 500084",
    email: "hyderabad@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Miles+Education+CPA+CMA+CAIRA+Hyderabad&ll=17.4585398,78.370688&t=&z=16&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Mumbai",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/mumbai.webp",
    address:
      "1st Floor, AJ House Abengoa, Marol Maroshi Rd, Gamdevi, Marol, Andheri East, Mumbai, Maharashtra 400059",
    email: "mumbai@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Miles+Education+CPA+CMA+CAIRA+Mumbai&ll=19.1122017,72.8792831&t=&z=16&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Delhi",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/delhi.webp",
    address:
      "3rd and 4th Floor, Old Fort Building, Near DLF Mall, Main Road, Saket, New Delhi, Delhi 110017",
    email: "delhincr@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Miles+Education+CPA+CMA+CAIRA+Delhi&ll=28.5289753,77.2163721&t=&z=16&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Ahmedabad",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/ahmedabad.webp",
    address:
      "704 Satyaone Complex, Near Helmet Cross Road, Memnagar, Ahmedabad - 380052",
    email: "ahmedabad@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Satyaone+Complex+Memnagar+Ahmedabad&t=&z=15&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Kochi",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/kochi.webp",
    address:
      "11th Floor, Muthoottu Royal Tower, 36, Banerji Road, Kaloor, Ernakulam, Kerala 682017",
    email: "kochi@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Muthoottu+Royal+Tower+Banerji+Road+Ernakulam+Kerala&t=&z=15&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Kolkata",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/kolkata.webp",
    address:
      "Collab Deck, 2/1, Russel St, Kankaria Estates, Park Street area, Kolkata, West Bengal 700071",
    email: "kolkata@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Collab+Deck+Russel+Street+Kankaria+Estates+Kolkata&t=&z=15&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Pune",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/pune.webp",
    address:
      "Sprint Workspace Wakadewadi, Old Mumbai - Pune Hwy, Narveer Tanaji Wadi, Shivajinagar, Pune, Maharashtra 411005",
    email: "pune@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Sprint+Workspace+Wakadewadi+Old+Mumbai+Pune+Hwy+Narveer+Tanaji+Wadi+Shivajinagar+Pune+Maharashtra+411005&t=&z=15&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Chennai",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/chennai.webp",
    address:
      "3rd Floor, 91 Springboard, Etica Malar Aurum, B-12, Guindy Industrial Estate, SIDCO Industrial Estate, Guindy, Chennai, Tamil Nadu 600032",
    email: "chennai@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=91+Springboard+Etica+Malar+Aurum+B-12+Guindy+Industrial+Estate+SIDCO+Industrial+Estate+Guindy+Chennai+Tamil+Nadu+600032&t=&z=15&ie=UTF8&iwloc=&output=embed",
  },
];

const IMAGE_FADE_DURATION_MS = 120;

const CITY_BORDER_IDLE =
  "[background:linear-gradient(#fff,#fff)_padding-box,linear-gradient(#e5e5e5,#e5e5e5)_border-box]";
const CITY_BORDER_ACTIVE =
  "[background:linear-gradient(#fff,#fff)_padding-box,linear-gradient(90deg,#B7D6FF_0%,#3399FF_100%)_border-box]";
const CITY_BORDER_HOVER =
  "hover:[background:linear-gradient(#fff,#fff)_padding-box,linear-gradient(90deg,#B7D6FF_0%,#3399FF_100%)_border-box]";

const NewPresence: React.FC<NewPresenceProps> = ({
  pageName,
  hideHeading = false,
  embedded = false,
}) => {
  const [activeImage, setActiveImage] = useState(officeImages[0]);
  const [activeCityIndex, setActiveCityIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isFading, setIsFading] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const fadeTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const activeCity = cities[activeCityIndex];

  const clearFadeTimeout = useCallback(() => {
    if (fadeTimeoutRef.current) {
      clearTimeout(fadeTimeoutRef.current);
      fadeTimeoutRef.current = null;
    }
  }, []);

  const queueImageChange = useCallback(
    (image: string) => {
      if (image === activeImage) return;
      clearFadeTimeout();
      setIsFading(true);
      fadeTimeoutRef.current = setTimeout(() => {
        setActiveImage(image);
        setIsFading(false);
        fadeTimeoutRef.current = null;
      }, IMAGE_FADE_DURATION_MS);
    },
    [activeImage, clearFadeTimeout],
  );

  useEffect(() => {
    if (isHovered) return;
    intervalRef.current = setInterval(() => {
      const currentIndex = officeImages.indexOf(activeImage);
      const nextIndex = (currentIndex + 1) % officeImages.length;
      queueImageChange(officeImages[nextIndex]);
    }, 3000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [activeImage, isHovered, queueImageChange]);

  useEffect(() => {
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      clearFadeTimeout();
    };
  }, [clearFadeTimeout]);

  return (
    <section
      className={
        embedded ? "" : "bg-white py-10 px-4 max-md:bg-[#f3f3f3] max-md:p-4"
      }
    >
      <div
        className={
          embedded
            ? ""
            : "main_container py-6 bg-white rounded-2xl max-md:px-4 max-md:py-6"
        }
      >
        {!hideHeading && (
          <>
            {/* Heading */}
            <div className="text-center mb-6">
              <h2 className="text-[32px] font-bold text-[#333] m-0 leading-[1.3] max-md:text-2xl">
                <span className="text-[#39f]">Best {pageName}</span> Coaching
                Institute in India
              </h2>
            </div>

            {/* Subtitle */}
            <p className="text-sm text-[#999] font-medium text-center mb-6">
              Visit the nearest Miles office or schedule Online Meet
            </p>
          </>
        )}

        {/* City Tabs */}
        <div className="flex flex-wrap gap-3 justify-center mb-8 max-md:grid max-md:grid-cols-3 max-md:gap-2">
          {cities.map((city, index) => (
            <button
              key={city.name}
              type="button"
              onClick={() => setActiveCityIndex(index)}
              className={`flex w-[105px] h-[105px] flex-col justify-center items-center gap-2 shrink-0 border border-transparent rounded-xl cursor-pointer transition-all duration-200 ${CITY_BORDER_HOVER} hover:shadow-[0_2px_8px_rgba(51,153,255,0.15)] max-md:w-full max-md:h-auto max-md:px-2 max-md:py-3 ${
                activeCityIndex === index
                  ? `${CITY_BORDER_ACTIVE} shadow-[0_2px_8px_rgba(51,153,255,0.15)]`
                  : CITY_BORDER_IDLE
              }`}
            >
              <img
                src={city.icon}
                alt={`${city.name} icon`}
                className="w-10 h-10 object-contain max-md:w-8 max-md:h-8"
                loading="lazy"
              />
              <span className="text-[14px] font-medium text-[#333] text-center max-md:text-[14px]">
                {city.name}
              </span>
            </button>
          ))}
        </div>

        {/* Contact Info Row */}
        <div className="grid grid-cols-[minmax(0,1fr)_minmax(0,320px)_minmax(0,200px)] gap-x-12 mb-8 max-md:grid-cols-1 max-md:gap-4 max-md:mb-6">
          {/* Address */}
          <div className="flex flex-col gap-1.5 md:max-w-[640px]">
            <span className="text-[12px] font-bold text-[#3399FF] tracking-widest uppercase">
              Address
            </span>
            <div className="flex items-start gap-2 text-xs md:text-base text-[#333] leading-snug">
              <svg
                className="w-4 h-4 mt-0.5 shrink-0 text-[#555]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              <span>{activeCity.address}</span>
            </div>
          </div>

          {/* Email */}
          <div className="flex flex-col gap-1.5">
            <span className="text-[12px] font-bold text-[#39f] tracking-widest uppercase">
              Email
            </span>
            <div className="flex items-center gap-2 text-xs md:text-base text-[#333]">
              <svg
                className="w-4 h-4 shrink-0 text-[#555]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              <a
                href={`mailto:${activeCity.email}`}
                className="hover:text-[#39f] transition-colors"
              >
                {activeCity.email}
              </a>
            </div>
          </div>

          {/* Mobile */}
          <div className="flex flex-col gap-1.5">
            <span className="text-[12px] font-bold text-[#39f] tracking-widest uppercase">
              Mobile
            </span>
            <div className="flex items-center gap-2 text-xs md:text-base text-[#333]">
              <svg
                className="w-4 h-4 shrink-0 text-[#555]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
              <a
                href={`tel:${activeCity.phone.replace(/\s/g, "")}`}
                className="hover:text-[#39f] transition-colors"
              >
                {activeCity.phone}
              </a>
            </div>
          </div>
        </div>

        {/* Map + Image Gallery */}
        <div className="grid grid-cols-[3fr_2fr] gap-4 max-md:grid-cols-1">
          {/* Google Map */}
          <div className="rounded-2xl overflow-hidden h-[360px] max-md:h-[260px]">
            <iframe
              key={activeCity.mapUrl}
              src={activeCity.mapUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title={`${activeCity.name} office location`}
            />
          </div>

          {/* Image Gallery */}
          <div
            className="relative rounded-2xl overflow-hidden h-[360px] max-md:h-[260px] bg-black"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <Image
              src={`${activeImage}&tr=w-770,h-720,q-60`}
              alt="Pan India Office Preview"
              width={770}
              height={720}
              className={`w-full h-full object-cover transition-opacity duration-150 ${
                isFading ? "opacity-0" : "opacity-100"
              }`}
              loading="lazy"
              sizes="(max-width: 767px) 100vw, 50vw"
            />

            {/* Thumbnails */}
            <div className="absolute bottom-3 left-[60px] flex gap-2 max-md:left-[48px] max-md:gap-1.5">
              {officeImages.map((image, index) => (
                <div
                  key={image}
                  onClick={() => queueImageChange(image)}
                  className={`relative w-[54px] h-[54px] max-md:w-[38px] max-md:h-[38px] rounded-md overflow-hidden cursor-pointer ${
                    activeImage === image
                      ? "ring-2 ring-white"
                      : "ring-1 ring-white/60"
                  }`}
                  aria-label={`Show office image ${index + 1}`}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      queueImageChange(image);
                    }
                  }}
                >
                  <Image
                    src={`${image}&tr=w-110,h-110,q-60`}
                    alt={`thumbnail-${index}`}
                    width={110}
                    height={110}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    sizes="60px"
                  />
                  {activeImage === image && (
                    <div className="absolute inset-0 bg-black/45 flex items-center justify-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="white"
                        className="w-4 h-4 md:w-5 md:h-5"
                      >
                        <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
                        <path
                          fillRule="evenodd"
                          d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewPresence;
